import React from "react";

// Non-null only inside the /cashier-preview iframe surface. When set, its value
// is the CASHIER_PREVIEW_CONFIG object posted by the back-office builder; the
// cashier data hooks read it to short-circuit every live fetch/mutation so the
// builder preview reuses the REAL render components without ever hitting the API.
export const CashierPreviewContext = React.createContext(null);

// Default VIP shape mirrors useVipDataSource's `vip` (see VipView.js): tierName,
// progressPct, benefits[], nextTierName, toNextLabel, nextTierBenefits[]. Used
// when the posted config omits `vip` so the VIP tab renders a plausible tier.
export const DEFAULT_PREVIEW_VIP = {
  tierName: "Bronze",
  progressPct: 35,
  toNextLabel: "650 points",
  nextTierName: "Silver",
  benefits: [{ label: "Weekly cashback", value: "5%" }],
  nextTierBenefits: [{ label: "Weekly cashback", value: "8%" }],
};

// Default eligible-campaigns list (POST /deposit/campaigns shape) used when the
// posted config omits `bonuses`. Empty = the bonuses list renders its empty state.
export const DEFAULT_PREVIEW_BONUSES = [];
